<template>
  <div class="wrap">
    <Header :class="`${'fixedHeader'}`" />
    <div class="banner">
      <!-- <img src="../../assets/image/useCases/useBanner.png" alt="" /> -->
      <img v-lazy="imgObj" alt="" />
    </div>
    <div class="main">
      <!-- 第一 -->
      <div class="first" ref="container">
        <div class="title">
          <h4>{{ $t("useCasesTitle1") }}</h4>
          <!-- <h4>Case of a well-known overseas financial platform</h4> -->
        </div>
        <div class="content">
          <!-- <img src="../../assets/image/useCases/one.png" alt="" /> -->
          <img
            v-if="launage === 'en_US'"
            src="../../assets/image/useCases/one.png"
            alt
          />
          <img
            v-if="launage === 'id'"
            src="../../assets/idImage/one-id.png"
            alt
          />
          <p>{{ $t("useCasesContent1") }}</p>
          <!-- <p>
            The client has been working in the field of overseas credit for many
            years, accumulated a large amount of self- owned data, and
            independently established the risk control model on this basis. In
            order to continue optimizing the model, wanted to introduce external
            data and products. After in-depth understanding, chose to cooperate
            with Seeder.
          </p> -->
        </div>
        <div class="content">
          <!-- <img src="../../assets/image/useCases/two.png" alt="" /> -->
          <img
            v-if="launage === 'en_US'"
            src="../../assets/image/useCases/two.png"
            alt
          />
          <img
            v-if="launage === 'id'"
            src="../../assets/idImage/two-id.png"
            alt
          />
          <p>{{ $t("useCasesContent2") }}</p>
          <!-- <p>
            Customers work closely with Seeder on anti-fraud products and risk
            assessment products, using facial recognition, face comparison and
            other technical means to identify fraud risks with different
            witnesses; Combined with customer's own data and external data
            output customer portrait, customer risk assessment, improve the
            accuracy of customer risk judgment.
          </p> -->
        </div>
        <div class="content">
          <!-- <img src="../../assets/image/useCases/three.png" alt="" /> -->
          <img
            v-if="launage === 'en_US'"
            src="../../assets/image/useCases/three.png"
            alt
          />
          <img
            v-if="launage === 'id'"
            src="../../assets/idImage/three-id.png"
            alt
          />
          <p>{{ $t("useCasesContent3") }}</p>
          <!-- <p>
            The application of Seeder reduced the overall risk of fraud,
            improved the identification rate of high-risk customers, and
            significantly reduced the first overdue rate and bad debt rate.
          </p> -->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default {
  name: "UseCases",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      launage: "",
      fixedHeader: false,
      // imgObj: {
      //   preLoad: 1,
      //   loading:require("../../assets/image/useCases/use-loading.jpg"),
      //   src: require("../../assets/image/useCases/useBanner.png"),
      //   error: require("../../assets/image/error.jpg"),
      // },
    };
  },
  computed: {
    imgObj() {
      if(this.launage === "en_US"){
        return {
          preLoad: 1,
          loading:require("../../assets/image/useCases/use-loading.jpg"),
          src: require("../../assets/image/useCases/useBanner.png"),
          error: require("../../assets/image/error.jpg"),
        };
      }else{
         return {
          preLoad: 1,
          loading: require("../../assets/idImage/compress_cn/useBanner-id.png"),
          src: require("../../assets/idImage/useBanner-id.png"),
          error: require("../../assets/image/error.jpg"),
        };
      }
    },
  },
  created() {
    this.launage = this.$i18n.locale;
    //获取滚动条高度处理头部导航
    window.onscroll = () => {
      // console.log(e)
      this.fixedHeader = document.documentElement.scrollTop >= 60;
    };
  },
};
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  .fixedHeader {
    position: fixed;
    background: black;
  }
  .absolute {
    position: absolute;
  }
}
.banner {
  width: 100%;
  min-height: 400px;
  img {
    display: block;
    width: 100%;
  }
}
.main {
  //第一
  .first {
    background: #fff;
    width: 62%;
    margin: auto;
    padding-top: 66px;
    margin-bottom: 90px;
    .title {
      font-size: 32px;
      font-family: MicrosoftYaHei-Bold;
      font-weight: bold;
      color: #000000;
      margin-bottom: 32px;
    }
    .content {
      margin-bottom: 54px;
      p {
        font-size: 18px;
        line-height: 1.6;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #071531;
        margin-top: 20px;
      }
    }
  }
}
</style>